
<template>
  <v-autocomplete v-if="lstCustomObjects?.length > 0"
                  v-model="value"
                  v-model:search="searchText"
                  item-title="name"
                  item-value="id"
                  :loading="loading"
                  :items="lstCustomObjects"
                  :return-object="returnObject"
                  hide-details
                  :custom-filter="customFilter"
                  :label="label"
                  clearable
                  :class="classes"
                  :multiple="multiple"
                  :required="required"
                  :rules="rules"
                  density="compact">
    <template v-slot:no-data>
      <div class="px-4">Digite sua busca</div>
    </template>
  </v-autocomplete>
  <p v-else-if="loading">Carregando Grupos/Tropas...</p>
  <p v-else>Nenhum Grupo/Tropa encontrado. Verifique o cadastro e/ou recarregue a página</p>
</template>
<script>
import api from '@/services'

export default {
  components: {},
  props: {
    user: Object,
    classes: String,
    label: String,
    modelValue: Object,
    returnObject: Boolean,
    multiple: Boolean,
    rules: Array,
    required: Boolean,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      requestingApi: false,
      selectedObject: null,
      searchText: null,
      previousSearch: null,
      loading: false,
      lstObjects: [],
      timeoutSearchDelay: null,
      enableSearch: false,
    };
  },
  created() {
    const vm = this;

    vm.submitSearch();
  },
  mounted() {
    const vm = this;

    vm.selectedObject = vm.selected || null;
  },
  methods: {
    waitAndSearch() {
      var vm = this;
      if (vm.timeoutSearchDelay) {
        clearTimeout(vm.timeoutSearchDelay);
      }
      if (vm.searchText != "" && vm.searchText != " ") {
        vm.timeoutSearchDelay = setTimeout(() => {
          vm.submitSearch();
        }, 800);
        vm.loading = true;
      }
    },
    customFilter(item, queryText, itemText) {
      return true
    },
    submitSearch() {
      const vm = this;

      vm.loading = true;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        let _searchText = vm.searchText;

        if (vm.enableSearch) {
          let _prev = (vm.previousSearch || "").toUpperCase();
          let _act = (_searchText || "").toUpperCase();
          if (_act == "" || (_act == " " && _prev == _act)) {
            vm.loading = false;
            vm.requestingApi = false;
            return;
          }
        }
        return new Promise((resolve, reject) => {
          api.subGroup
            .list({
              searchText: vm.searchText
            }, 1)
            .then((result) => {
              vm.previousSearch = _searchText;
              vm.lstObjects = result;
              resolve(result);
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
              reject(err);
            })
            .finally(() => {
              vm.requestingApi = false;
              vm.loading = false;
            });
        });
      }
    },
  },
  computed: {
    lstCustomObjects() {
      const vm = this;

      return vm.lstObjects?.map(obj => {
        const _name = `${obj.name} [${obj.id}]`;

        return {
          ...obj,
          _name: _name,
        };
      });
    },
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    selectedObject(newVal) {
      this.$emit('selected', newVal)
    },

    searchText(newVal, oldVal) {
      if (
        !oldVal ||
        newVal &&
        newVal != " " &&
        newVal.toUpperCase() != oldVal.toUpperCase()
      ) {
        this.waitAndSearch();
      }
    },
  },
};
</script>
